import {API_KEY} from "./my_key.js";
import {verse, verse01} from "./verse.js";


export function chapter01(){var activities_chapter = document.getElementById("chapter_type");
  activities_chapter.addEventListener("change", function() {
    var x = activities_chapter.selectedIndex;

    verse(activities_chapter.options[activities_chapter.selectedIndex].id,activities_chapter.options[activities_chapter.selectedIndex].value,document.getElementById("bible_type").options[document.getElementById("bible_type").selectedIndex].value);

});
  //important 12/4/2022: to initialized just once the bible stuff
verse01();  
}
  
export async function chapter(book,version,abbr){
      var jsonArray = [];
  const bibleChapterList = document.querySelector(`#chapter-list`);
      const bibleSectionList = document.querySelector(`#section-list`);
      var bibleVersionID = version;
      var bibleBookID = book;
      var abbreviation = abbr;

      let chapterHTML = ``;
      let sectionHTML = ``;


 document.getElementById("chapter_type").innerText = null;
    await getChapters(bibleVersionID, bibleBookID).then((chapterList) => {
        console.log(chapterList);
        for (let chapter of chapterList) {
            var option = document.createElement("option");
            option.id = chapter.id;
            option.value =bibleVersionID;
            option.text = chapter.number;
            //document.getElementById("chapter_type").add(option);
                     var jsonObject = {
  "id": chapter.id,
  "value":bibleVersionID,
  "text": chapter.number
};

jsonArray.push(jsonObject);
        }
          });

    return jsonArray;

}

      /**
       * Gets chapters from API.Bible
       * @param {string} bibleVersionID to get chapters from
       * @param {string} bibleBookID to get chapters from
       * @returns {Promise} containing list of chapters from selected book
       */
      function getChapters(bibleVersionID, bibleBookID) {
  
        return new Promise((resolve, reject) => {
          const xhr = new XMLHttpRequest();
          xhr.withCredentials = false;

          xhr.addEventListener(`readystatechange`, function() {
            if (this.readyState === this.DONE) {
              const {data} = JSON.parse(this.responseText);
              const chapters = data.map( ({number, id}) => { return {number, id}; } );

              resolve(chapters);
            }
          });


          xhr.open(`GET`, `https://api.scripture.api.bible/v1/bibles/${bibleVersionID}/books/${bibleBookID}/chapters`);
          xhr.setRequestHeader(`api-key`, API_KEY);

          xhr.onerror = () => reject(xhr.statusText);

          xhr.send();
        });
      }

      /**
       * Gets sections from API.Bible
       * @param {string} bibleVersionID to get sections from
       * @param {string} bibleBookID to get sections from
       * @returns {Promise} containing list of sections from selected book
       */
      function getSections(bibleVersionID, bibleBookID) {
        return new Promise((resolve, reject) => {
          const xhr = new XMLHttpRequest();
          xhr.withCredentials = false;

          xhr.addEventListener(`readystatechange`, function() {
            if (this.readyState === this.DONE) {
              const {data} = JSON.parse(this.responseText);
              const sections = data ? data.map( ({title, id}) => { return {title, id}; } ) : null;

              resolve(sections);
            }
          });

          xhr.open(`GET`, `https://api.scripture.api.bible/v1/bibles/${bibleVersionID}/books/${bibleBookID}/sections`);
          xhr.setRequestHeader(`api-key`, API_KEY);

          xhr.onerror = () => reject(xhr.statusText);

          xhr.send();
        });
      }

      /**
       * Gets query parameter from URL based on name
       * @param {string} name of query parameter
       * @returns {string} value of query parameter
       */
      function getParameterByName(name) {
        const url = window.location.href;
        name = name.replace(/[\[\]]/g, `\\$&`);
        const regex = new RegExp(`[?&]` + name + `(=([^&#]*)|&|#|$)`),
          results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return ``;
        return decodeURIComponent(results[2].replace(/\+/g, ` `));
      }

      /**
       * Loads page for new search
      /* 
  This function is not yet being utalized much ... 2/3/2023
   function searchButton(){
      const searchInput = document.querySelector(`#search-input`);
      window.location.href = `./search.html?&version=${bibleVersionID}&abbr=${abbreviation}&query=${searchInput.value}`;
    }*/